import { useEffect, useState } from 'react';
import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { CheckBox } from 'react-native-elements';
import { appTheme } from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

import { styles } from './styles';

type CustomCheckBoxProps = {
  label?: string | React.ReactNode;
  onChecked: (value: boolean) => void;
  disabled?: boolean;
  checkedColor?: string;
  checked: boolean;
  isLabelComponent?: boolean;
  testID?: string;
};

export const CustomCheckBox = ({
  label,
  onChecked,
  disabled,
  checkedColor,
  checked,
  isLabelComponent,
  testID,
}: CustomCheckBoxProps) => {
  const [check, setCheck] = useState(false);

  const onSetCheck = () => {
    setCheck(!check);
    onChecked(check);
  };

  useEffect(() => {
    setCheck(checked);
  }, [checked]);
  return (
    <View style={styles.wrapper}>
      <CheckBox
        testID={testID}
        containerStyle={styles.checkBoxContainerStyle}
        checked={check}
        onPress={() => onSetCheck()}
        checkedColor={checkedColor || appTheme.primary}
        disabled={disabled || false}
        size={IS_WEB ? useResponsiveFontSize(2) : useResponsiveFontSize(3)}
      />
      {isLabelComponent ? label : <Text>{label}</Text>}
    </View>
  );
};

export default CustomCheckBox;
